export const IMAGES_UPLOAD_REQUEST = "IMAGES_UPLOAD_REQUEST";
export const IMAGES_UPLOAD_SUCCESS = "IMAGES_UPLOAD_SUCCESS";
export const IMAGES_UPLOAD_FAIL = "IMAGES_UPLOAD_FAIL";
export const IMAGES_UPLOAD_RESET = "IMAGES_UPLOAD_RESET";

export const IMAGE_UPLOAD_REQUEST = "IMAGE_UPLOAD_REQUEST";
export const IMAGE_UPLOAD_SUCCESS = "IMAGE_UPLOAD_SUCCESS";
export const IMAGE_UPLOAD_FAIL = "IMAGE_UPLOAD_FAIL";
export const IMAGE_UPLOAD_RESET = "IMAGE_UPLOAD_RESET";

export const PDF_UPLOAD_REQUEST = "PDF_UPLOAD_REQUEST";
export const PDF_UPLOAD_SUCCESS = "PDF_UPLOAD_SUCCESS";
export const PDF_UPLOAD_FAIL = "PDF_UPLOAD_FAIL";

export const IMAGE_REMOVE_REQUEST = "IMAGE_REMOVE_REQUEST";
export const IMAGE_REMOVE_SUCCESS = "IMAGE_REMOVE_SUCCESS";
export const IMAGE_REMOVE_FAIL = "IMAGE_REMOVE_FAIL";